export default "__VITE_ASSET__3ZTAQ1o8__"